module.exports = __webpack_public_path__ + "static/img/g101.1a646fff.png";